import React, { useState, useEffect } from 'react';
import styled from 'styled-components';

const RSVPBanner: React.FC<{ isEnabled?: boolean }> = ({ isEnabled = true }) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    if (!isEnabled) return;

    const bannerDismissed = localStorage.getItem('rsvpBannerDismissed');
    if (!bannerDismissed) {
      setIsVisible(true);
    }
  }, [isEnabled]);

  const handleRSVPClick = () => {
    const contactSection = document.getElementById('kontakt');

    if (contactSection) {
      contactSection.scrollIntoView({ behavior: 'smooth' });
    }

    setIsVisible(false);
  };

  const handleDismissClick = () => {
    localStorage.setItem('rsvpBannerDismissed', 'true');
    setIsVisible(false);
  };

  if (!isEnabled || !isVisible) return null;

  return (
    <Banner>
      <Text>
        Daj znać, że będziesz! 🎉
      </Text>
      <Buttons>
        <RSVPButton onClick={handleRSVPClick}>Daję znać</RSVPButton>
        <DismissButton onClick={handleDismissClick}>Nie pokazuj ponownie</DismissButton>
      </Buttons>
    </Banner>
  );
};

const Banner = styled.div`
  position: fixed;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  background-color: #fff;
  border: 1px solid #ddd;
  border-radius: 10px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
  padding: 20px;
  max-width: 90%;
  width: 400px;
  z-index: 1000;
  display: flex;
  flex-direction: column;
  align-items: center;

  @media (max-width: 768px) {
    width: 90%;
    padding: 15px;
  }
`;

const Text = styled.p`
  font-size: 1.2rem;
  color: #333;
  text-align: center;
  margin-bottom: 15px;

  @media (max-width: 768px) {
    font-size: 1rem;
  }
`;

const Buttons = styled.div`
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
  justify-content: center;
`;

const RSVPButton = styled.button`
  background-color: #007bff;
  color: #fff;
  border: none;
  border-radius: 5px;
  padding: 10px 20px;
  font-size: 1rem;
  cursor: pointer;
  transition: background-color 0.3s;

  &:hover {
    background-color: #0056b3;
  }

  @media (max-width: 768px) {
    font-size: 0.9rem;
    padding: 8px 15px;
  }
`;

const DismissButton = styled.button`
  background-color: #ddd;
  color: #333;
  border: none;
  border-radius: 5px;
  padding: 10px 20px;
  font-size: 1rem;
  cursor: pointer;
  transition: background-color 0.3s;

  &:hover {
    background-color: #bbb;
  }

  @media (max-width: 768px) {
    font-size: 0.9rem;
    padding: 8px 15px;
  }
`;

export default RSVPBanner;